class LocalizationForm extends HTMLElement {
  constructor() {
    super()

    this.onItemClick = this.onItemClick.bind(this)
  }

  connectedCallback() {
    this.input = this.querySelector('input[name="country_code"]')

    this.querySelectorAll('a.header-currency-item').forEach((item) =>
      item.addEventListener('click', this.onItemClick)
    )
  }

  disconnectedCallback() {
    this.querySelectorAll('a.header-currency-item').forEach((item) =>
      item.removeEventListener('click', this.onItemClick)
    )
  }

  onItemClick(event) {
    event.preventDefault()
    const form = this.querySelector('form')
    this.input.value = event.currentTarget.dataset.value
    if (form) form.submit()
  }
}

customElements.define('localization-form', LocalizationForm)
